import { IModuleProps } from '@msdyn365-commerce-modules/utilities';
import classNames from 'classnames';
import { computed, toJS } from 'mobx';
import { observer } from 'mobx-react';
import * as React from 'react';
import { Label } from 'reactstrap';
import { IGetBillingDocumentsResponse } from '../../actions/get-billing-documents.action';
import { DateLocale, Separator } from '../../actions/user-preferences/get-localization.action';
import { LOCALIZATION_DEFAULT_TIMEZONE } from '../../configuration/localization';
import { ILocalizationState } from '../../states/localization-state';
import { ILxsBillingDocumentsData } from './lxs-billing-documents.data';
import { ILxsBillingDocumentsProps } from './lxs-billing-documents.props.autogenerated';

export interface ILxsBillingDocumentsViewProps extends ILxsBillingDocumentsProps<ILxsBillingDocumentsData> {
    billingDocuments: IGetBillingDocumentsResponse;
    LxsBillingDocumentsProps: IModuleProps;
    localizationState: ILocalizationState;
}

@observer
class LxsBillingDocuments extends React.PureComponent<ILxsBillingDocumentsProps<ILxsBillingDocumentsData>> {
    @computed
    get billingDocuments(): IGetBillingDocumentsResponse | undefined {
        const result = this.props.data?.getBillingDocuments?.result;

        if (!result) {
            return undefined;
        }

        const allDocuments = Array.isArray(result)
            ? result.flatMap((r: { value?: any[] }) => r.value || [])
            : (result as { value?: any[] }).value || [];

        return { value: toJS(allDocuments) };
    }

    private readonly defaultLocalization: ILocalizationState = {
        numberLocale: {
            thousandSeparator: Separator.Dot,
            decimalSeparator: Separator.Comma
        },
        dateLocale: DateLocale.US,
        timeZone: LOCALIZATION_DEFAULT_TIMEZONE
    };

    public render(): JSX.Element | null {
        const { data, resources, renderView } = this.props;

        if (!data) {
            return null;
        }

        const billingDocuments = this.billingDocuments;
        if (!billingDocuments) {
            return resources?.loadingLabel ? <Label className='lxs-billing-documents__loading'>{resources.loadingLabel}</Label> : null;
        }

        const localizationState = toJS(data.localizationState?.result) ?? this.defaultLocalization;

        const viewProps: ILxsBillingDocumentsViewProps = {
            ...this.props,
            billingDocuments,
            localizationState,
            LxsBillingDocumentsProps: {
                moduleProps: this.props,
                className: classNames('lxs-billing-documents')
            }
        };

        return renderView(viewProps);
    }
}

export default LxsBillingDocuments;
